import {
  campaignUpdateSchema,
  populatedCampaignSchema,
} from "@redotech/redo-model/campaigns/campaign-definition";

export const updateCampaign = {
  name: "updateCampaign" as const,
  input: campaignUpdateSchema,
  output: populatedCampaignSchema,
};
